import { useFolderPermissionsDrawer } from '~/elc/features/folder-permissions/hooks/useFolderPermissionsDrawer';

import AssetPickerEditOption from './asset-picker-edit-option';

const AssetPickerAddFolderCollabsOption = ({ folder }) => {
  const openDrawer = useFolderPermissionsDrawer(folder.id);

  return (
    <div className="flex asset-picker-edit-option asset-picker-add-folder-collabs">
      <AssetPickerEditOption
        title="Add/Remove access to this folder"
        src="/images/new_ui_share_icon.svg"
        height="100%"
        onClick={openDrawer}
      />
    </div>
  );
};

export default AssetPickerAddFolderCollabsOption;
